import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";

type Props = {
  count?: number;
  className?: string;
}

function AutomationListsSkeleton(props: Props) {
  const { className, count } = props;
  return (
    <WrapperStyle className={`${className ?? ""}`}>
      <div className="inner-wrapper">
        <div className="loader-wrapper">
          {Array.from(Array(count).keys()).map((item, index) => (
            <ContentLoader
              key={index}
              style={{ backgroundColor: "#FFFFFF", margin: "0px 0px", borderRadius: "1px", height: "30px" }}
              {...props}
              width={'100%'}
            >
              <rect x="0" y="0" rx="4" ry="4" width={20 + "px"} height="20" />
              <rect x="30" y="0" rx="4" ry="4" width={95 + "%"} height="20" />
            </ContentLoader>
          ))}
        </div>
      </div>
    </WrapperStyle>
  );
}

AutomationListsSkeleton.defaultProps = {
  count: 6,
}

export default AutomationListsSkeleton;

const WrapperStyle = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  &.list-data-loader {
    display: unset;
    align-items: unset;
  }
  .inner-wrapper {
    width: 100%;
    .loader-wrapper {
      width: calc(100% - 30px);
      svg {
        width: 100%;
      }
    }
  }
`;
